import React, { useContext } from 'react';
import { ResponsiveContext } from 'grommet';
import { withRouter, Route } from 'react-router-dom';

import { Box } from 'components/Wrapped';
import { AnalyticsContainer, NavCoinPicker } from 'containers/TopBar';

import { withNamespaces } from 'react-i18next';
import LayoutPreference from './LayoutPreference';

const SkinnyBar = ({ t }) => {
  const size = useContext(ResponsiveContext);

  return (
    <Box
      pad={{ horizontal: 'small' }}
      round={false}
      direction="row"
      justify="end"
      wrap={true}
      background="background-6"
      flex={false}
      height={size === 'small' ? '165px' : '50px'}
      style={size === 'small' ? { paddingTop: '20px' } : undefined}
    >
      <Box
        pad="none"
        round={false}
        alignSelf="start"
        align="center"
        flex="grow"
        justify={size === 'small' ? 'center' : 'start'}
        direction="row"
        fill="vertical"
      >
        <Route
          path="/"
          render={({ location }) =>
            location.pathname.includes('/trade/') && (
              <Box pad="none" direction="row" gap="24px">
                <NavCoinPicker size={size} />
                <AnalyticsContainer size={size} />
              </Box>
            )
          }
        />
      </Box>
      <LayoutPreference />
    </Box>
  );
};

export default withNamespaces()(withRouter(SkinnyBar));
